import { shape, number, string } from 'prop-types';

export default shape({
    level: string,
    id: number,
});
